import type { User } from "@prisma/client";
import clsx from "clsx";
import { match } from "ts-pattern";

import { getUserDisplayName } from "~/utils/user";

import { AvatarPlaceholder } from "./AvatarPlaceholder";

export const Avatar: React.FC<{
  size?: "sm" | "md" | "lg" | "xl";
  user: Pick<User, "id" | "avatar" | "name" | "username" | "email">;
}> = ({ user, size = "md" }) => {
  const displayName = getUserDisplayName(user);
  return (
    <div
      className={clsx(
        "flex overflow-hidden rounded-full bg-base-300",
        match(size)
          .with("sm", () => "size-5")
          .with("md", () => "size-8")
          .with("lg", () => "size-12")
          .with("xl", () => "size-16")
          .exhaustive(),
      )}
    >
      {user.avatar ? (
        <img
          className="grow object-cover"
          draggable={false}
          src={user.avatar}
          alt={displayName}
          key={user.avatar}
        />
      ) : (
        <AvatarPlaceholder seed={user.id.toString()}>
          {displayName.charAt(0).toUpperCase()}
        </AvatarPlaceholder>
      )}
    </div>
  );
};
